"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = objectValueSort;
function objectValueSort(first, second, key) {
  let reverse = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  const value1 = first[key];
  const value2 = second[key];
  if (isNaN(value1)) {
    if (!reverse) {
      return value1.localeCompare(value2);
    } else {
      return value2.localeCompare(value1);
    }
  } else {
    if (!reverse) {
      return value1 - value2;
    } else {
      return value2 - value1;
    }
  }
}